import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemBorderOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-border-option';
import type {BorderType} from '@/poster-whiteboard/classes/item-border.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';

interface ItemBorderOptionProps {
  onClickColorFill(): void;
}

export function ItemBorderOption({...props}: ItemBorderOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemBorderType = useGetKeyFromBorderOfActiveItem('solidBorderType');
  const activeItemBorderColor = useGetKeyFromBorderOfActiveItem('solidBorderColor');
  const activeItemBorderThickness = useGetKeyFromBorderOfActiveItem('solidBorderThickness');

  if (!activeItem || (activeItem && !('border' in activeItem)) || activeItemBorderThickness === undefined || !activeItemBorderColor || activeItemBorderType === undefined) {
    throw new Error('item does not have border property');
  }

  const onClickHandler = (clickedId: BorderType): void => {
    void activeItem.updateFromObject({
      border: {
        solidBorderType: Number(clickedId),
      },
    });
  };

  const updateThickness = (solidBorderThickness: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        border: {
          solidBorderThickness,
        },
      },
      {
        undoable,
      }
    );
  };

  return (
    <BaseItemBorderOption
      borderObject={{
        solidBorderThickness: activeItemBorderThickness,
        solidBorderType: activeItemBorderType,
        solidBorderColor: activeItemBorderColor,
      }}
      showStrokeBorderOption={activeItem.isImage() && activeItem.isStrokeBorderSupported()}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
      onChangeBorder={onClickHandler}
      updateThickness={updateThickness}
      isForLayout={activeItem.isTableItem() || activeItem.isMenu()}
    />
  );
}
